<template>
  <a-card :bordered="false">

    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
<!--          <a-col :md="7" :sm="8">-->
<!--            <a-form-item label="Dictionary name" :labelCol="{span: 6}" :wrapperCol="{span: 14, offset: 1}">-->
<!--              <a-input placeholder="Please enter dictionary name" v-model="queryParam.dictName"></a-input>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :md="7" :sm="8">-->
<!--            <a-form-item label="Dictionary code" :labelCol="{span: 6}" :wrapperCol="{span: 14, offset: 1}">-->
<!--              <a-input placeholder="Please enter dictionary code" v-model="queryParam.dictCode"></a-input>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <a-col :md="7" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">Search</a-button>
<!--              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">Reset</a-button>-->
            </span>
          </a-col>
        </a-row>
      </a-form>

<!--      <div class="table-operator" style="border-top: 5px">-->
<!--        <a-button @click="handleAdd" type="primary" icon="plus">Add</a-button>-->
<!--      </div>-->

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        bordered
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
<!--          <a @click="handleEdit(record)">-->
<!--            <a-icon type="edit"/>-->
<!--            Edit-->
<!--          </a>-->
<!--          <a-divider type="vertical"/>-->
          <a @click="editDictItem(record)"><a-icon type="setting"/> Dictionary Configuration</a>
<!--          <a-divider type="vertical"/>-->
<!--          <a-popconfirm title="Confirm delete??" @confirm="() =>handleDelete(record.id)">-->
<!--            <a>Delete</a>-->
<!--          </a-popconfirm>-->
           <a-divider type="vertical"/>
           <a @click="clearCache(record.id)"> Clear Cache</a>
        </span>
      </a-table>

    </div>
    <dict-modal ref="modalForm" @ok="modalFormOk"></dict-modal>
    <dict-item-list ref="dictItemList"></dict-item-list>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getDict, deleteDict, clearDictCache } from '@/webpublicapi/system'
import DictModal from './modules/DictModal'
import DictItemList from './DictItemList'
export default {
  name: 'DictList',
  components: { DictModal, DictItemList },
  data () {
    return {
      visible: false,
      // Pagination params
      ipagination: {
        current: 1,
        pageSize: 30,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' Total ' + total + ' records'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      dataSource: [],
      // Query conditions
      queryParam: {
        dictCode: '',
        dictName: ''
      },
      loading: false,
      // Table header
      columns: [
        {
          title: 'Dictionary Name',
          align: 'left',
          dataIndex: 'dictName'
        },
        {
          title: 'Dictionary Code',
          align: 'left',
          dataIndex: 'dictCode'
        },
        {
          title: 'Description',
          align: 'left',
          dataIndex: 'description'
        },
        {
          title: 'Action',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      isorter: {
        column: 'createTime',
        order: 'desc'
      },

      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  created () {
    this.loadData(1)
  },
  methods: {
    searchQuery () {
      this.loadData(1)
    },
    loadData (arg) {
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams()// Query conditions
      getDict(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows
        }else{
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
            this.loading = false;
            this.$message.error(e.message);
      })
    },
    getQueryParams () {
      var param = Object.assign({}, this.queryParam, this.isorter)
      param.pageNum = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      param.dictCode = "mobileGoogleWhiteList"
      return filterObj(param)
    },
    handleTableChange (pagination, filters, sorter) {
      // TODO Filter
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field
        this.isorter.order = sorter.order === 'ascend' ? 'asc' : 'desc'
      }
      this.ipagination = pagination
      this.loadData()
    },
    handleAdd () {
      this.$refs.modalForm.add()
      this.$refs.modalForm.title = 'Add'
    },
    handleEdit (record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = 'Edit'
    },
    handleDelete(id){
      deleteDict({id}).then((res) => {
        if (res.code === 1000) {
          this.$message.success(res.msg)
          this.loadData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    clearCache(id){
      clearDictCache({id}).then((res) => {
        if (res.code === 1000) {
          this.$message.success(res.msg)
        }else{
          this.$message.warning(res.msg)
        }
      })
    },
    // Edit dictionary data
    editDictItem (record) {
      this.$refs.dictItemList.edit(record)
    },
    // Reset dictionary type search box content
    searchReset () {
      var that = this
      that.queryParam.dictName = ''
      that.queryParam.dictCode = ''
      that.loadData(this.ipagination.current)
    },
    // modelCallback
    modalFormOk () {
      this.loadData()
    }
  }
}
</script>
<style lang="less" scoped>
 @import "~@/assets/less/common.less";
</style>
